// Shared constants for Conversio™ landing page
export const WHATSAPP_NUMBER = "919920965870";
export const WHATSAPP_TEXT =
  "Hi, I want to turn my WhatsApp into a Revenue Multiplier. Can you help me choose the right Conversio package?";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_TEXT
)}`;

// Book-call CTA — user will provide real URL later; placeholder anchor for now
export const BOOK_CALL_URL = "https://cal.id/prajakta-badhe/funnel-strategy-call";

export const BRAND = "Conversio";
export const BRAND_FULL = "Conversio\u2122 \u2014 WhatsApp Revenue System";
